import { S_LANG, S_SESSION_ID, webStorage } from "../utils/webStorage";
import api from "../utils/api";
import store from "../redux/store/store";
import { clearCartAction, setSessionIdAction, updateCartAction } from "../redux/actions/actions";
import { getBrandNameFromGems, getCategoriesFromSpuIds } from "../utils/gear";
import { setDisabledSkuidsAction } from "../redux/actions/gears-checkout";

let cartRefreshTimeout = null;
let cartRefreshSeconds = 5 * 60;
export const getCart = async lang => {
  const sessionId = webStorage.get(S_SESSION_ID);
  // const token = webStorage.get(S_AUTH_TOKEN);
  const body = { sessionId };
  const res = await api.shoppingCart.merge(null, body);
  const spuIds = res.obj.skuList?.map(item => item.spuId) || [];
  const gearsReqBody = {
      itemPath: "/sitecore/content/lynkco-global-portal/Content/Gear",
      language: lang || "en",
      spuIds: spuIds
    },
    gears = await api.gears.list(null, gearsReqBody);
  const categories = gears.spuIds ? getCategoriesFromSpuIds(gears.spuIds) : undefined;
  if (gears.spuIds && res.obj.skuList)
    for (const skuItem of res.obj.skuList) {
      const spuItem = gears.spuIds.data.find(spuItem => spuItem.spuId === skuItem.spuId);
      let scBrand, scProduct;
      skuItem.spuName = spuItem?.productName;
      for (let index = 0; index < gears.sitecoreGearItems.length; index++) {
        const brand = gears.sitecoreGearItems[index];
        scProduct = brand.products.find(product => Number(product.spuId) === Number(spuItem?.spuId));
        scBrand = scProduct ? brand : undefined;
        if (scProduct) break;
      }
      if (scBrand && scProduct && categories?.length) {
        skuItem.brandName = getBrandNameFromGems(scBrand.categoryId, categories);
        skuItem.categories = categories;
        skuItem.parentCategoryId = categories.find(cat => cat.categoryId === Number(scBrand.categoryId))?.parentId;
        skuItem.parentCategoryName = skuItem.parentCategoryId ? categories.find(cat => cat.categoryId === Number(skuItem.parentCategoryId))?.categoryName : undefined;
        skuItem.scBrandName = scBrand.scBrandName;
        skuItem.scProductName = scProduct.scProductName;
        !skuItem.skuAttributes.find(item => item.label === skuItem.parentCategoryName) &&
          skuItem.skuAttributes.push({
            label: skuItem.parentCategoryName,
            value: skuItem.brandName
          });
      }
      const { obj: promotions } = await api.user.promotion(null, {
        skuIds: [skuItem.skuId]
      });
      skuItem.unitPriceDiscounted = skuItem.unitPrice;
      if (promotions.length) {
        promotions.forEach(element => {
          if (element.discountRate) skuItem.unitPriceDiscounted -= (element.discountRate / 100) * skuItem.unitPrice;
          if (element.subAmt) skuItem.unitPriceDiscounted -= element.subAmt;
        });
      }
      skuItem.promotionTotal = (skuItem.unitPrice - skuItem.unitPriceDiscounted) * skuItem.skuCount;
    }
  store.dispatch(updateCartAction(res.obj));
  store.dispatch(setSessionIdAction(res.obj.sessionId));
  return res;
};
export const addCartItem = async skuId => {
  stopCheckCart();
  const sessionId = webStorage.get(S_SESSION_ID);
  // const token = webStorage.get(S_AUTH_TOKEN);
  const body = {
    promotions: [
      //   {
      //     promotionId: 0,
      //     promotionType: "string"
      //   }
    ],
    skuId: skuId,
    skuCount: 1,
    sessionId
  };
  const res = await api.shoppingCart.merge(null, body);
  store.dispatch(updateCartAction(res.obj));
  store.dispatch(setSessionIdAction(res.obj.sessionId));
  startCheckCart();
  return res;
};
export const removeCartItem = async (skuId, skuCount) => {
  const res = await removeCartItems([{ skuId, skuCount }]);
  return res;
};
export const removeCartItems = async skus => {
  stopCheckCart();
  const sessionId = webStorage.get(S_SESSION_ID);
  // const token = webStorage.get(S_AUTH_TOKEN);
  const body = {
    skus,
    sessionId
  };
  const res = await api.shoppingCart.remove(null, body);
  store.dispatch(updateCartAction(res.obj));
  startCheckCart();
  return res;
};
export const clearCart = async skuIds => {
  stopCheckCart();
  const sessionId = webStorage.get(S_SESSION_ID);
  const res = await api.shoppingCart.remove(null, {
    skus: skuIds,
    sessionId
  });
  store.dispatch(clearCartAction());
  startCheckCart();
  return res;
};

const callCheckCartApi = async skuIds => {
  const { obj } = await api.shoppingCart.check(null, {
    skuIds
  });
  return obj;
};
const doCheckCart = async () => {
  const lang = webStorage.get(S_LANG);
  const { obj } = await getCart(lang);
  if (obj.skuList) {
    const skuIds = obj.skuList.map(e => e.skuId);
    const { disabledSkuIds } = await callCheckCartApi(skuIds);
    store.dispatch(setDisabledSkuidsAction(disabledSkuIds));
  } else {
    store.dispatch(setDisabledSkuidsAction([]));
  }
  cartRefreshTimeout = setTimeout(doCheckCart, cartRefreshSeconds * 1000);
};
export const startCheckCart = () => {
  cartRefreshTimeout = setTimeout(doCheckCart, cartRefreshSeconds * 1000);
};
export const stopCheckCart = () => {
  if (cartRefreshTimeout) {
    clearTimeout(cartRefreshTimeout);
  }
};
